import React from 'react'
import { cn } from '@/utils'
import { DollarSign, TrendingUp, TrendingDown, Building2 } from 'lucide-react'

export interface PortfolioMetricCardProps {
  icon: 'invested' | 'current' | 'gain' | 'assets'
  label: string
  value: string
  subValue?: string
  trend?: 'up' | 'down'
  className?: string
  chart?: React.ReactNode
}

const iconMap = {
  invested: DollarSign,
  current: TrendingUp,
  gain: TrendingDown,
  assets: Building2,
}

export const PortfolioMetricCard: React.FC<PortfolioMetricCardProps> = ({
  icon,
  label,
  value,
  subValue,
  trend,
  className,
  chart,
}) => {
  const Icon = iconMap[icon]

  return (
    <div
      className={cn(
        'relative bg-white dark:bg-[#121212] h-[124px] overflow-hidden',
        'border border-[rgba(45,41,35,0.08)] dark:border-[rgba(253,253,253,0.08)] rounded-none',
        className
      )}
    >
      {/* Main content */}
      <div className="absolute flex flex-col items-start justify-center left-[24px] top-0 h-full z-10">
        {/* Header with icon and label */}
        <div className="flex gap-[6px] items-center w-full mb-2">
          <div className="shrink-0 size-[16px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]">
            <Icon className="w-full h-full" strokeWidth={1.5} />
          </div>
          <p className="font-['Plus_Jakarta_Sans'] font-medium leading-[18px] text-[13px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]">
            {label}
          </p>
        </div>

        {/* Value and sub-value */}
        <div className="flex flex-col gap-1">
          <p className="font-['Plus_Jakarta_Sans'] font-medium leading-[32px] text-[#2d2923] dark:text-[#fdfdfd] text-[23px] tracking-[-0.2px]">
            {value}
          </p>
          {subValue && (
            <div className="flex items-center gap-1">
              {trend === 'up' ? <TrendingUp size={12} className="text-[#2ea66b]" /> : <TrendingDown size={12} className="text-[#ff540c]" />}
              <p className={`text-[13px] font-medium ${
                trend === 'up' ? 'text-[#2ea66b]' : 'text-[#ff540c]'
              }`}>
                {subValue}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Chart content */}
      {chart && (
        <div className="absolute right-0 top-0 h-full flex items-center pr-4">
          {chart}
        </div>
      )}
    </div>
  )
}

export default PortfolioMetricCard
